// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ../~/@master/webinfra-frontend-components/src/components/VerticalLabel/VerticalLabel.less
// module id = 1403
// module chunks = 0